interface IconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

/** Tick / checkmark. */
export function Check({ size = 15, color = '#62A158', strokeWidth = 2.6, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M20 6L9 17l-5-5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Document with a checked corner — "a living checklist". */
export function DocCheck({ size = 24, color = '#62A158', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <rect x="4" y="3" width="16" height="18" rx="2.5" stroke={color} strokeWidth="1.8" />
      <path d="M8 9h5M8 13h6" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
      <path
        d="M15.5 16.5l1.4 1.4 2.6-2.8"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Speech bubble — "an advisor that knows UK law". */
export function Chat({ size = 24, color = '#5862A1', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M4 5.5A1.5 1.5 0 015.5 4h13A1.5 1.5 0 0120 5.5v9A1.5 1.5 0 0118.5 16H9l-4 4V5.5z"
        stroke={color}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M8 9h8M8 12h5" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

/** Person — "real experts, one click away". */
export function Person({ size = 24, color = '#62A158', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <circle cx="12" cy="8" r="3.4" stroke={color} strokeWidth="1.8" />
      <path
        d="M5.5 20c0-3.3 2.9-5.5 6.5-5.5s6.5 2.2 6.5 5.5"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Padlock — the "safe place to ask" / expiry cues. */
export function Lock({ size = 14, color = '#B7BCE0', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <rect x="5" y="11" width="14" height="9" rx="2" stroke={color} strokeWidth="1.8" />
      <path d="M8 11V8a4 4 0 018 0v3" stroke={color} strokeWidth="1.8" />
    </svg>
  );
}
